import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { MeDataType } from '@/types';

import axiosInstance from '@/lib/axios-instance';
import { API_ROUTES } from '@/lib/routes/api-routes';

const switchRole = async (role: string) => {
  const { data } = await axiosInstance.patch(API_ROUTES.users.switchRole, {
    activeRole: role,
  });

  return data;
};

const useSwitchRole = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: switchRole,

    onSuccess: (data: MeDataType) => {
      queryClient.setQueryData(['me'], data);
    },
  });
};

export default useSwitchRole;
